import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { useHistory, useLocation } from 'react-router-dom';
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import { LoadPanel } from 'devextreme-react/load-panel';
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import Toolbar, { Item } from "devextreme-react/toolbar";
import FormField from '../../../dynamicFormBuilder/FormField';
import { WMStorageMiscDpLookupLayout } from '../../../common/lookups/Layouts/WMLayouts';
import { IDCustomerLookupLayout } from '../../../common/lookups/Layouts/IdLayouts';
import { ACDepartmentLayout } from '../../../common/lookups/Layouts/ACLayouts';
import { CAJobLayout } from '../../../common/lookups/Layouts/CALayouts';
import { FAFundLayout } from '../../../common/lookups/Layouts/FALayouts';
import data from "../../../assets/apiRoutes.json";
import axios from "axios";
import notify from 'devextreme/ui/notify';
import { custom } from 'devextreme/ui/dialog';
import {
    Column,
    DataGrid,
    Scrolling,
    FilterRow,
    Editing,
    Export,
    Selection,
    Toolbar as DataGridToolbar,
    Item as DataGridToolbarItem,
    RequiredRule,
    StateStoring,
    ColumnChooser
} from "devextreme-react/data-grid";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import RenderSelectBoxCell from '../../../common/RenderCell';
import { confirm } from 'devextreme/ui/dialog';
import GridLayoutManager from '../../../gridLayoutCustomization/GridLayoutManager';
import { GridLayout } from '../../../common/GridLayout';
import StorageChargesTab from './tabs/StorageChargesTab';
import TransactionChargesGrid from './tabs/TransactionChargesTab';
import MiscChargesGrid from './tabs/MiscChargesTab';

const PrimaryLayout = [
    {
        "groupId": 1,
        "fields": [
            {
                "name": "RECORD",
                "tableName": "WMTRANSACTIONCHARGE",
                "label": "Record",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PROFILECODE",
                "tableName": "WMTRANSACTIONCHARGE",
                "label": "Profile Code",
                "type": "lookup",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": true,
                "visible": true,
                "isLabelChanged": false,
                "layout": WMStorageMiscDpLookupLayout
            },
            {
                "name": "CUSTOMER",
                "tableName": "WMTRANSACTIONCHARGE",
                "label": "Customer",
                "type": "lookup",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "layout": IDCustomerLookupLayout()
            },
            {
                "name": "TRANSACTIONTYPE",
                "tableName": "WMTRANSACTIONCHARGE",
                "label": "Transaction Type",
                "type": "select",
                "options": [
                    { "Rowid": "M", "Code": "Miscellaneous" },
                    { "Rowid": "C", "Code": "Storage" }
                ],
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "TRANSACTIONNUMBER",
                "tableName": "WMTRANSACTIONCHARGE",
                "label": "Transaction Number",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": false,
            },
            {
                "name": "TRANSACTIONDATE",
                "tableName": "WMTRANSACTIONCHARGE",
                "label": "Transaction Date",
                "type": "date",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "REFERENCE",
                "tableName": "WMTRANSACTIONCHARGE",
                "label": "Reference",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "STATUS",
                "tableName": "WMTRANSACTIONCHARGE",
                "label": "Status",
                "type": "select",
                "options": [
                    { "Rowid": "O", "Code": "Open" },
                    { "Rowid": "H", "Code": "Hold" },
                    { "Rowid": "L", "Code": "Ready To Commit Later" },
                    { "Rowid": "Z", "Code": "Committed" }
                ],
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "TotalChargesCount",
                "tableName": "WMTRANSACTIONCHARGE",
                "label": "# of Charges",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": false,
            },
            {
                "name": "ItemTotalQuanity",
                "tableName": "WMTRANSACTIONCHARGE",
                "label": "Total Quantity",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": false,
            },
            {
                "name": "ItemTotalChargeAmount",
                "tableName": "WMTRANSACTIONCHARGE",
                "label": "Total Amount",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": false,
            }
        ]
    },{
        "groupId": 2,
        "fields": [
            {
                "name": "CustomerAddress",
                "tableName": "WMTRANSACTIONCHARGE",
                "label": "",
                "type": "textarea",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerCreditLimit",
                "tableName": "WMTRANSACTIONCHARGE",
                "label": "Credit Limit",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerCreditBalance",
                "tableName": "WMTRANSACTIONCHARGE",
                "label": "Current Balance",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerCreditRemaning",
                "tableName": "WMTRANSACTIONCHARGE",
                "label": "Remaning Credit",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": false,
            }
        ]
    }
];

// Base AdditionalLayout - will be made dynamic based on transaction type
const getAdditionalLayout = (transactionType, isEditMode = false) => {
    const isStorage = transactionType === 'C';
    
    return [
        {
            "groupId": 1,
            "label": "Miscellaneous/Transaction Charges",
            "fields": [
                {
                    "name": "RATESCHEDULE",
                    "tableName": "WMTRANSACTIONHEADER",
                    "label": "Rate Schedule",
                    "type": "select",
                    "options": null,
                    "apiUrl": null,
                    "grid": null,
                    "required": false,
                    "visible": true,
                    "readOnly": isEditMode,
                    "isLabelChanged": false,
                }
            ]
        },
        {
            "groupId": 2,
            "label": "Accounting",
            "fields": [
                {
                    "name": "R_GLDEPARTMENT",
                    "tableName": "WMTRANSACTIONHEADER",
                    "label": "Department",
                    "type": "lookup",
                    "options": null,
                    "apiUrl": null,
                    "grid": null,
                    "required": false,
                    "visible": true,
                    "readOnly": isStorage,
                    "isLabelChanged": true,
                    "layout": ACDepartmentLayout
                },
                {
                    "name": "R_CAJOB",
                    "tableName": "WMTRANSACTIONHEADER",
                    "label": "Job",
                    "type": "lookup",
                    "options": null,
                    "apiUrl": null,
                    "grid": null,
                    "required": false,
                    "visible": true,
                    "readOnly": isStorage,
                    "isLabelChanged": true,
                    "layout": CAJobLayout
                },
                {
                    "name": "R_GLFUND",
                    "tableName": "WMTRANSACTIONHEADER",
                    "label": "Fund",
                    "type": "lookup",
                    "options": null,
                    "apiUrl": null,
                    "grid": null,
                    "required": false,
                    "visible": true,
                    "readOnly": isStorage,
                    "isLabelChanged": true,
                    "layout": FAFundLayout
                }
            ]
        },
        {
            "groupId": 3,
            "fields": [
                {
                    "name": "COMMENT",
                    "tableName": "WMTRANSACTIONHEADER",
                    "label": "Comment",
                    "type": "text",
                    "options": null,
                    "apiUrl": null,
                    "grid": null,
                    "required": false,
                    "visible": true,
                    "isLabelChanged": false,
                }
            ]
        }
    ];
};

function Form(props) {
    const history = useHistory();
    const location = useLocation();
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const position = { of: '#root' };
    const formRefs = useRef({});
    
    const queryString = location.search;
    const urlParams = new URLSearchParams(queryString);
    const id = urlParams.get('id') || props.id;

    const initialFormFields = {
        ROWID: '00000000-0000-0000-0000-000000000000',
        RECORD: '',
        PROFILECODE: '',
        CUSTOMER: '',
        TRANSACTIONTYPE: 'M',
        TRANSACTIONNUMBER: '',
        TRANSACTIONDATE: null,
        REFERENCE: '',
        STATUS: 'L', // Default to "Ready To Commit Later" for new records
        TotalChargesCount: '0', // Default to 1 if no charges
        ItemTotalQuanity: '0.00', // Default to 0.00
        ItemTotalChargeAmount: '0.00', // Default to 0.00
        CustomerAddress: '',
        CustomerCreditLimit: '',
        CustomerCreditBalance: '',
        CustomerCreditRemaning: '',
        RATESCHEDULE: '',
        R_GLDEPARTMENT: null,
        R_CAJOB: null,
        R_GLFUND: null,
        COMMENT: '',
        TRANSACTIONHEADERID: '', // Store the transaction header rowid after save
    };

    const [formFields, setformFields] = useState(initialFormFields);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const tabPanelRef = useRef(null);
    const chargesGridRef = useRef(null);
    const transactionChargesGridRef = useRef(null);
    const storageItemsGridRef = useRef(null);
    const storageChargesGridRef = useRef(null);
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const [selectedTransactionItemKeys, setSelectedTransactionItemKeys] = useState([]);
    const [selectedStorageItemsKeys, setSelectedStorageItemsKeys] = useState([]);
    const [selectedStorageChargesKeys, setSelectedStorageChargesKeys] = useState([]);
    const [currentLayout, setCurrentLayout] = useState("Default");
    const [currentTransactionLayout, setCurrentTransactionLayout] = useState("Default");
    const [currentStorageItemsLayout, setCurrentStorageItemsLayout] = useState("Default");
    const [currentStorageChargesLayout, setCurrentStorageChargesLayout] = useState("Default");
    var accessToken = currentUser?.access_token;

    const handleFieldChange = useCallback((name, value) => {
        // Extract value if it's an object (from SelectBox)
        let fieldValue = value;
        if (value && typeof value === 'object' && value.id !== undefined) {
            fieldValue = value.id;
        } else if (value && typeof value === 'object' && value.value !== undefined) {
            fieldValue = value.value;
        }
        
        // Log field changes for TransactionDate and Reference
        if (name === 'TRANSACTIONDATE' || name === 'REFERENCE') {
            console.log(`handleFieldChange - Field: ${name}, Original Value:`, value, 'Type:', typeof value, 'Converted Value:', fieldValue);
        }
        
        setformFields(prevFields => {
            const updatedFields = {
                ...prevFields,
                [name]: fieldValue
            };
            
            // If transaction type changes to "C" (Storage), clear and disable accounting fields
            if (name === 'TRANSACTIONTYPE') {
                if (fieldValue === 'C') {
                    // Clear accounting fields when changing to Storage
                    updatedFields.R_GLDEPARTMENT = null;
                    updatedFields.R_CAJOB = null;
                    updatedFields.R_GLFUND = null;
                    
                    // Disable accounting fields immediately via refs if they exist
                    setTimeout(() => {
                        const accountingFields = ['R_GLDEPARTMENT', 'R_CAJOB', 'R_GLFUND'];
                        accountingFields.forEach(fieldName => {
                            if (formRefs.current && formRefs.current[fieldName]) {
                                formRefs.current[fieldName].instance().option('disabled', true);
                            }
                        });
                    }, 100);
                } else if (fieldValue === 'M') {
                    // Enable accounting fields when changing to Miscellaneous
                    setTimeout(() => {
                        const accountingFields = ['R_GLDEPARTMENT', 'R_CAJOB', 'R_GLFUND'];
                        accountingFields.forEach(fieldName => {
                            if (formRefs.current && formRefs.current[fieldName]) {
                                formRefs.current[fieldName].instance().option('disabled', false);
                            }
                        });
                    }, 100);
                }
            }
            
            return updatedFields;
        });
    }, []);

    const loadLookupClient = useCallback((name, data) => {
        try {
            const newOptions = data.map(item => ({
                id: item.Rowid,
                name: item.Code
            }));
            if (formRefs.current && formRefs.current[name]) {
                const ref = formRefs.current[name];
                if (typeof ref.instance === 'function') {
                    const instance = ref.instance();
                    if (instance && typeof instance.option === 'function') {
                        instance.option('dataSource', newOptions);
                        instance.option('valueExpr', 'id');
                        instance.option('displayExpr', 'name');
                    }
                }
            }
        } catch (error) {
            console.error('Error loading lookup:', error);
        }
    }, []);

    const loadLookupFromDataSource = useCallback((name, dataSource) => {
        try {
            if (formRefs.current && formRefs.current[name]) {
                const ref = formRefs.current[name];
                if (typeof ref.instance === 'function') {
                    const instance = ref.instance();
                    if (instance && typeof instance.option === 'function') {
                        instance.option('dataSource', dataSource);
                        instance.option('valueExpr', 'id');
                        instance.option('displayExpr', 'name');
                    }
                }
            }
        } catch (error) {
            console.error('Error loading lookup from data source:', error);
        }
    }, []);

    const handleFormLoad = useCallback(() => {
        // Load transaction type options
        var transactionTypes = [
            { "Rowid": "M", "Code": "Miscellaneous" },
            { "Rowid": "C", "Code": "Storage" }
        ];
        loadLookupClient("TRANSACTIONTYPE", transactionTypes);
        
        // Load status options
        var statusOptions = [
            { "Rowid": "O", "Code": "Open" },
            { "Rowid": "H", "Code": "Hold" },
            { "Rowid": "L", "Code": "Ready To Commit Later" },
            { "Rowid": "Z", "Code": "Committed" }
        ];
        loadLookupClient("STATUS", statusOptions);

        // Load rate schedule data source
        var rateScheduleDataSource = new DataSource({
            store: new createStore({
                key: 'id',
                loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetRateSchedules`,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            paginate: true,
            pageSize: 100
        });

        loadLookupFromDataSource("RATESCHEDULE", rateScheduleDataSource);
    }, [loadLookupClient, loadLookupFromDataSource, accessToken]);

     

     
    const loadTransactionHeaderById = useCallback(async (rowid) => {
        try {
            setLoadPanelVisible(true);
            const response = await axios.get(`${window._env_.REACT_APP_APIS}/wm/Transaction/GetTransactionByRowId?rowid=${rowid}`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            });

            if (response.data) {
                const data = response.data;
                // WMTransactionHeaderModel uses uppercase property names
                const transactionNumber = data.TRANSACTIONNUMBER || data.transactionNumber || data.TransactionNumber || '';
                const recordNo = data.RECORDNO || data.recordNo || data.RECORD || data.record || '';
                const transactionType = data.TRANSACTIONTYPE || data.transactionType || data.Transactiontype || '';
                const transactionHeaderId = data.ROWID || data.rowid || data.Rowid || '';
                
                setformFields(prevFields => {
                    const statusValue = data.STATUS || data.status || data.Status || prevFields.STATUS;
                    const updatedFields = {
                        ...prevFields,
                        ROWID: transactionHeaderId || prevFields.ROWID,
                        RECORD: recordNo,
                        TRANSACTIONHEADERID: transactionHeaderId || prevFields.TRANSACTIONHEADERID,
                        PROFILECODE: data.R_SMCHARGESPROFILE || data.rSmchargesprofile || data.RSmchargesprofile || prevFields.PROFILECODE,
                        CUSTOMER: data.R_CUSTOMER || data.rCustomer || data.RCustomer || prevFields.CUSTOMER,
                        TRANSACTIONTYPE: transactionType,
                        TRANSACTIONNUMBER: transactionNumber,
                        TRANSACTIONDATE: data.TRANSACTIONDATE || data.transactionDate || data.TransactionDate || prevFields.TRANSACTIONDATE,
                        REFERENCE: data.REFERENCE || data.reference || data.Reference || prevFields.REFERENCE,
                        STATUS: statusValue,
                        COMMENT: data.COMMENT || data.comment || data.Comment || prevFields.COMMENT,
                        ItemTotalQuanity: data.itemTotalQuanity || data.ItemTotalQuanity,
                        ItemTotalChargeAmount: data.itemTotalChargeAmount || data.ItemTotalChargeAmount,
                        CustomerCreditLimit: data.customerCreditLimit || data.CustomerCreditLimit,
                        CustomerAddress: data.customerAddress || data.CustomerAddress,
                        CustomerCreditBalance: data.customerCreditBalance || data.CustomerCreditBalance,
                        CustomerCreditRemaning: data.customerCreditRemaning || data.CustomerCreditRemaning,
                        TotalChargesCount: data.totalChargesCount || data.TotalChargesCount,
                        RATESCHEDULE: data.R_RATESCHEDULE || data.rRateschedule || data.RRateschedule || data.Rateschedule || prevFields.RATESCHEDULE,
                    };
                    
                    // If transaction type is "C" (Storage), clear accounting fields
                    if (transactionType === 'C') {
                        updatedFields.R_GLDEPARTMENT = null;
                        updatedFields.R_CAJOB = null;
                        updatedFields.R_GLFUND = null;
                    } else {
                        updatedFields.R_GLDEPARTMENT = data.R_GLDEPARTMENT || data.rGldepartment || data.RGldepartment || prevFields.R_GLDEPARTMENT;
                        updatedFields.R_CAJOB = data.R_CAJOB || data.rCajob || data.RCajob || prevFields.R_CAJOB;
                        updatedFields.R_GLFUND = data.R_GLFUND || data.rGlfund || data.RGlfund || prevFields.R_GLFUND;
                    }
                    
                    return updatedFields;
                });
                
                 
                
                // Make transaction number field visible after loading
                const transactionNumberField = PrimaryLayout[0].fields.find(f => f.name === 'TRANSACTIONNUMBER');
                if (transactionNumberField && transactionNumber) {
                    transactionNumberField.visible = true;
                }

                // Load transaction type options after setting the value
                var transactionTypes = [
                    { "Rowid": "M", "Code": "Miscellaneous" },
                    { "Rowid": "C", "Code": "Storage" }
                ];
                loadLookupClient("TRANSACTIONTYPE", transactionTypes);
                
                // Load status options after setting the value
                var statusOptions = [
                    { "Rowid": "O", "Code": "Open" },
                    { "Rowid": "H", "Code": "Hold" },
                    { "Rowid": "L", "Code": "Ready To Commit Later" },
                    { "Rowid": "Z", "Code": "Committed" }
                ];
                loadLookupClient("STATUS", statusOptions);

                // Load rate schedule data source
                var rateScheduleDataSource = new DataSource({
                    store: new createStore({
                        key: 'id',
                        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetRateSchedules`,
                        onBeforeSend: function (method, ajaxOptions) {
                            ajaxOptions.headers = {
                                Authorization: `Bearer ${accessToken}`
                            };
                        }
                    }),
                    paginate: true,
                    pageSize: 100
                });

                loadLookupFromDataSource("RATESCHEDULE", rateScheduleDataSource);

                // Set rate schedule value if it exists
                const rateScheduleValue = data.R_RATESCHEDULE || data.rRateschedule || data.RRateschedule || data.Rateschedule || null;
                if (rateScheduleValue) {
                    setformFields(prevFields => ({
                        ...prevFields,
                        RATESCHEDULE: rateScheduleValue
                    }));
                }

                // Disable rate schedule field for edit mode - try multiple times to ensure it's applied
                const disableRateSchedule = () => {
                    if (formRefs.current && formRefs.current["RATESCHEDULE"]) {
                        const ref = formRefs.current["RATESCHEDULE"];
                        if (typeof ref.instance === 'function') {
                            const instance = ref.instance();
                            if (instance && typeof instance.option === 'function') {
                                instance.option('disabled', true);
                                return true;
                            }
                        }
                    }
                    return false;
                };

                // Try immediately
                if (!disableRateSchedule()) {
                    // Try after short delay
                    setTimeout(() => {
                        if (!disableRateSchedule()) {
                            // Try after longer delay
                            setTimeout(disableRateSchedule, 300);
                        }
                    }, 100);
                }
            }
        } catch (error) {
            console.error('Error loading transaction header:', error);
            notify(
                {
                    message: "Error loading transaction header",
                    width: 300,
                },
                'error',
                3000,
            );
        } finally {
            setTimeout(() => setLoadPanelVisible(false), 500);
        }
    }, [accessToken, loadLookupClient, loadLookupFromDataSource]);

    useEffect(() => {
        if (id && id !== '00000000-0000-0000-0000-000000000000' && id !== '') {
            loadTransactionHeaderById(id);
        } else {
            handleFormLoad();
             
        }
    }, [id, loadTransactionHeaderById, handleFormLoad]);

    // Ensure Rate Schedule is disabled in edit mode
    useEffect(() => {
        const isEditMode = id && id !== '00000000-0000-0000-0000-000000000000' && id !== '';
        if (isEditMode) {
            const disableRateSchedule = () => {
                if (formRefs.current && formRefs.current["RATESCHEDULE"]) {
                    const ref = formRefs.current["RATESCHEDULE"];
                    if (typeof ref.instance === 'function') {
                        const instance = ref.instance();
                        if (instance && typeof instance.option === 'function') {
                            instance.option('disabled', true);
                            return true;
                        }
                    }
                }
                return false;
            };

            // Try to disable immediately and with retries
            if (!disableRateSchedule()) {
                const timer1 = setTimeout(() => {
                    if (!disableRateSchedule()) {
                        const timer2 = setTimeout(() => {
                            disableRateSchedule();
                        }, 500);
                        return () => clearTimeout(timer2);
                    }
                }, 200);
                return () => clearTimeout(timer1);
            }
        }
    }, [id, formFields.RATESCHEDULE]);
    
 
    
     

    useEffect(() => {
        // Apply styles directly to TabPanel container
        const applyStyles = () => {
            // Use document.querySelector as fallback since ref might not be ready
            const container = document.querySelector('.charges-tabpanel-wrapper .dx-tabpanel-container') ||
                             document.querySelector('.charges-tabpanel .dx-tabpanel-container') ||
                             document.querySelector('.dx-tabpanel-container');
            if (container) {
                container.style.marginTop = '8px';
                container.style.minHeight = '82vh';
                container.style.background = '#ffffff';
                container.style.borderRadius = '12px';
                container.style.border = '1px solid #d3d3d3';
            }
        };
        
        // Try immediately and also after a short delay to ensure DOM is ready
        applyStyles();
        const timeoutId = setTimeout(applyStyles, 100);
        const timeoutId2 = setTimeout(applyStyles, 500);
        
        return () => {
            clearTimeout(timeoutId);
            clearTimeout(timeoutId2);
        };
    }, [id]);

    const goBack = () => {
        history.push('/wm/charges/search-charges');
    };

    const handleFormSubmit = async () => {
        setLoadPanelVisible(true);
        setIsFormSubmitted(true);
        try {
            await saveStorageMiscDp();
        } catch (error) {
            console.error('Error submitting form:', error);
            setIsFormSubmitted(false);
        } finally {
            setTimeout(() => setLoadPanelVisible(false), 1000);
        }
    };

    const saveStorageMiscDp = async () => {
        try {
            const url = "wm/TransactionCharge/SaveChargesFromProfile";
            
            const isEmptyGuid = formFields.ROWID === '00000000-0000-0000-0000-000000000000' || !formFields.ROWID;
            
            // Ensure Transactiontype is a string value (extract from object if needed)
            let transactionTypeValue = formFields.TRANSACTIONTYPE;
            if (transactionTypeValue && typeof transactionTypeValue === 'object') {
                transactionTypeValue = transactionTypeValue.id || transactionTypeValue.value || 'M';
            }
            transactionTypeValue = transactionTypeValue || 'M';
            
            console.log('Transaction Type Value:', transactionTypeValue, 'Form Fields TRANSACTIONTYPE:', formFields.TRANSACTIONTYPE);
            
            // Handle TransactionDate - convert to proper format or null
            console.log('=== SAVE DEBUG START ===');
            console.log('formFields.TRANSACTIONDATE:', formFields.TRANSACTIONDATE, 'Type:', typeof formFields.TRANSACTIONDATE);
            console.log('formFields.REFERENCE:', formFields.REFERENCE, 'Type:', typeof formFields.REFERENCE);
            console.log('All formFields:', formFields);
            
            let transactionDateValue = null;
            if (formFields.TRANSACTIONDATE) {
                console.log('TRANSACTIONDATE exists, processing...');
                // If it's already a Date object, convert to ISO string
                if (formFields.TRANSACTIONDATE instanceof Date) {
                    transactionDateValue = formFields.TRANSACTIONDATE.toISOString();
                    console.log('TRANSACTIONDATE is Date object, converted to ISO:', transactionDateValue);
                } else if (typeof formFields.TRANSACTIONDATE === 'string' && formFields.TRANSACTIONDATE.trim() !== '') {
                    // If it's a string, try to parse it as a date
                    console.log('TRANSACTIONDATE is string:', formFields.TRANSACTIONDATE);
                    const parsedDate = new Date(formFields.TRANSACTIONDATE);
                    if (!isNaN(parsedDate.getTime())) {
                        transactionDateValue = parsedDate.toISOString();
                        console.log('TRANSACTIONDATE string parsed successfully:', transactionDateValue);
                    } else {
                        transactionDateValue = formFields.TRANSACTIONDATE;
                        console.log('TRANSACTIONDATE string could not be parsed, using as-is:', transactionDateValue);
                    }
                } else {
                    console.log('TRANSACTIONDATE is not Date or non-empty string, value:', formFields.TRANSACTIONDATE);
                }
            } else {
                console.log('TRANSACTIONDATE is falsy (null/undefined/empty)');
            }
            
            // Handle Reference - convert empty string to null
            let referenceValue = null;
            if (formFields.REFERENCE) {
                console.log('REFERENCE exists, processing...');
                if (typeof formFields.REFERENCE === 'string' && formFields.REFERENCE.trim() !== '') {
                    referenceValue = formFields.REFERENCE.trim();
                    console.log('REFERENCE is non-empty string, trimmed:', referenceValue);
                } else {
                    console.log('REFERENCE is not a non-empty string, value:', formFields.REFERENCE, 'Type:', typeof formFields.REFERENCE);
                    referenceValue = formFields.REFERENCE || null;
                }
            } else {
                console.log('REFERENCE is falsy (null/undefined/empty)');
            }
            
            console.log('Final transactionDateValue:', transactionDateValue);
            console.log('Final referenceValue:', referenceValue);
            console.log('=== SAVE DEBUG END ===');
            
            console.log('Accounting fields from formFields:');
            console.log('R_GLDEPARTMENT:', formFields.R_GLDEPARTMENT);
            console.log('R_CAJOB:', formFields.R_CAJOB);
            console.log('R_GLFUND:', formFields.R_GLFUND);
            
            // Handle Comment - convert empty string to null
            const commentValue = formFields.COMMENT && typeof formFields.COMMENT === 'string' && formFields.COMMENT.trim() !== ''
                ? formFields.COMMENT.trim()
                : (formFields.COMMENT || null);
            
            // Handle Status - extract from object if needed
            let statusValue = formFields.STATUS;
            if (statusValue && typeof statusValue === 'object') {
                statusValue = statusValue.id || statusValue.value || 'L';
            }
            statusValue = statusValue || 'L'; // Default to "L" if not provided
            
            const dto = {
                rowId: isEmptyGuid ? '00000000-0000-0000-0000-000000000000' : formFields.ROWID,
                profileCode: formFields.PROFILECODE || '',
                customer: formFields.CUSTOMER || null,
                transactionType: transactionTypeValue,
                transactionDate: transactionDateValue,
                reference: referenceValue,
                status: statusValue,
                rGlDepartment: formFields.R_GLDEPARTMENT || null,
                rCajob: formFields.R_CAJOB || null,
                rGlFund: formFields.R_GLFUND || null,
                comment: commentValue,
                description: '',
                userDefinedCode1: '',
                userDefinedCode2: '',
                userDefinedCode3: '',
                userDefinedCode4: '',
                userDefinedCode5: '',
                chargeTypes: '',
                recurringCharge: '',
                transNoGenerationMisc: '',
                transactionPrefix: '',
                allowDuplicatePo: '',
                rateSchedule: formFields.RATESCHEDULE && typeof formFields.RATESCHEDULE === 'object' 
                    ? (formFields.RATESCHEDULE.id || formFields.RATESCHEDULE.value || '') 
                    : (formFields.RATESCHEDULE || ''),
            };

            console.log('=== DTO BEING SENT ===');
            console.log('Full DTO object:', JSON.stringify(dto, null, 2));
            console.log('TransactionDate in DTO:', dto.TransactionDate);
            console.log('Reference in DTO:', dto.Reference);
            console.log('DTO keys:', Object.keys(dto));
            console.log('=== END DTO ===');

            const response = await axios.post(`${window._env_.REACT_APP_APIS}/${url}`, dto, {
                headers: {
                    'Content-Type': 'application/json',
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });

            console.log('Response:', response);
            console.log('Response Data:', response.data);

            if (response.data && (response.data.status === 'success' || response.data.STATUS === 'success' || response.data.STATUS === 'Success')) {
                const transactionNumber = response.data.transactionNumber || response.data.transactionnumber;
                const transactionDate = response.data.transactionDate || response.data.TransactionDate;
                const newTransactionHeaderId = response.data.rowId || response.data.rowid || response.data.ROWID;
                
                setformFields(prevFields => ({
                    ...prevFields,
                    ROWID: newTransactionHeaderId || prevFields.ROWID,
                    RECORD: response.data.record || response.data.RECORD || prevFields.RECORD,
                    TRANSACTIONHEADERID: newTransactionHeaderId || prevFields.TRANSACTIONHEADERID, // Store transaction header ID
                    TRANSACTIONNUMBER: transactionNumber || prevFields.TRANSACTIONNUMBER,
                    TRANSACTIONDATE: transactionDate || prevFields.TRANSACTIONDATE
                }));
                
              
                
                // Update PrimaryLayout to make TRANSACTIONNUMBER visible after save
                if (transactionNumber) {
                    const transactionNumberField = PrimaryLayout[0].fields.find(f => f.name === 'TRANSACTIONNUMBER');
                    if (transactionNumberField) {
                        transactionNumberField.visible = true;
                    }
                }
                // Refresh charges grid if it exists and is initialized
                // Refresh Misc Charges grid for Miscellaneous type
                if (formFields.TRANSACTIONTYPE === 'M' && chargesGridRef.current && chargesGridRef.current.instance && typeof chargesGridRef.current.instance === 'function') {
                    try {
                        chargesGridRef.current.instance().refresh();
                    } catch (error) {
                        // Grid may not be ready yet, ignore error
                        console.log('Misc Charges grid refresh skipped:', error);
                    }
                }
                // Refresh Transaction Charges grid for Storage type
                if (formFields.TRANSACTIONTYPE === 'C' && transactionChargesGridRef.current && transactionChargesGridRef.current.instance && typeof transactionChargesGridRef.current.instance === 'function') {
                    try {
                        transactionChargesGridRef.current.instance().refresh();
                    } catch (error) {
                        // Grid may not be ready yet, ignore error
                        console.log('Transaction Charges grid refresh skipped:', error);
                    }
                }
                notify(
                    {
                        message: "Transaction charge saved successfully",
                        width: 300,
                    },
                    'success',
                    3000,
                );
                setIsFormSubmitted(false);
            } else if (response.data && ((response.data.errors && response.data.errors.length > 0) || (response.data.ERRORS && response.data.ERRORS.length > 0))) {
                const errors = response.data.errors || response.data.ERRORS || [];
                const errorHtml = errors.map(err => `<div>${err}</div>`).join('');
                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();
                setIsFormSubmitted(false);
            }
        } catch (error) {
            console.error('Error saving storage misc DP:', error);
            if (error.response && error.response.data && error.response.data.ERRORS && error.response.data.ERRORS.length > 0) {
                const errorHtml = error.response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();
            } else {
                notify(
                    {
                        message: "Could not save storage misc DP. An error occurred",
                        width: 100,
                    },
                    'error',
                    3000,
                );
            }
            setIsFormSubmitted(false);
        }
    };

    return (
        <div>
            <div className="row dataEntryMainPage">
                <div className="col-md-12 main-page">
                    <div id="accordion">
                        <LoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            position={position}
                            onHiding={() => setLoadPanelVisible(false)}
                            visible={loadPanelVisible}
                            showIndicator={true}
                            shading={true}
                            showPane={true}
                            hideOnOutsideClick={false}
                        />
                        <Toolbar 
                            className="header" 
                            style={{
                                borderStyle: 'solid',
                                borderRadius: '12px',
                                marginBottom: '8px',
                                borderWidth: '1px',
                                borderColor: '#d3d3d3',
                            }}
                        >
                            <Item location="before">
                                <div className="title">
                                    <h6
                                        style={{
                                            color: window._env_.Color2,
                                            marginLeft: '12px'
                                        }}
                                    >
                                        Transaction Charge
                                    </h6>
                                </div>
                            </Item>
                            <Item location="after">
                                <Button 
                                    text="Save"
                                    onClick={handleFormSubmit}
                                    disabled={isFormSubmitted}
                                    type="default"
                                    className="accordianButton"
                                />
                            </Item>
                            <Item location="after">
                                <Button className="accordianButton" onClick={goBack} text="Back" />
                            </Item>
                        </Toolbar>
                        <div className="charges-tabpanel-wrapper">
                            <TabPanel 
                                ref={tabPanelRef}
                                className="charges-tabpanel" 
                                deferRendering={id ? true : false} 
                                showNavButtons={true} 
                                height={"auto"}
                                style={{ minHeight: '50vh' }}
                            >
                                <TabItem title="Primary">
                                    <FormField
                                        currrentUser={currentUser}
                                        layoutId='6712abab-afbb-483a-a85f-cacc4f514063'
                                        layoutName='ChargesPrimaryForm'
                                        defaultFormSchema={PrimaryLayout}
                                        formFields={formFields}
                                        setformFields={setformFields}
                                        handleFieldValueChange={handleFieldChange}
                                        DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                        formRefs={formRefs}
                                        onFormLoad={handleFormLoad}
                                    />
                                </TabItem>
                                <TabItem title="Additional">
                                    <FormField
                                        currrentUser={currentUser}
                                        layoutId='e359b377-e20e-4579-b4c9-6ab31daa2cc0'
                                        layoutName='ChargesAdditionalForm'
                                        defaultFormSchema={useMemo(() => getAdditionalLayout(formFields.TRANSACTIONTYPE, id && id !== '00000000-0000-0000-0000-000000000000' && id !== ''), [formFields.TRANSACTIONTYPE, id])}
                                        formFields={formFields}
                                        setformFields={setformFields}
                                        handleFieldValueChange={handleFieldChange}
                                        DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                        formRefs={formRefs}
                                        onFormLoad={handleFormLoad}
                                    />
                                </TabItem>
                                <TabItem 
                                    title="Misc Charges" 
                                    disabled={
                                        !formFields.TRANSACTIONHEADERID || 
                                        formFields.TRANSACTIONHEADERID === '00000000-0000-0000-0000-000000000000' ||
                                        formFields.TRANSACTIONTYPE === 'C'
                                    }
                                >
                                    <MiscChargesGrid 
                                        transactionHeaderId={formFields.TRANSACTIONHEADERID}
                                        accessToken={accessToken}
                                        chargesGridRef={chargesGridRef}
                                        selectedItemKeys={selectedItemKeys}
                                        setSelectedItemKeys={setSelectedItemKeys}
                                        currentLayout={currentLayout}
                                        setCurrentLayout={setCurrentLayout}
                                       
                                    />
                                </TabItem>
                                <TabItem 
                                    title="Transaction Charges" 
                                    disabled={
                                        !formFields.TRANSACTIONHEADERID || 
                                        formFields.TRANSACTIONHEADERID === '00000000-0000-0000-0000-000000000000' ||
                                        formFields.TRANSACTIONTYPE !== 'C'
                                    }
                                >
                                    <TransactionChargesGrid 
                                        transactionHeaderId={formFields.TRANSACTIONHEADERID}
                                        accessToken={accessToken}
                                        chargesGridRef={transactionChargesGridRef}
                                        selectedItemKeys={selectedTransactionItemKeys}
                                        setSelectedItemKeys={setSelectedTransactionItemKeys}
                                        currentLayout={currentTransactionLayout}
                                        setCurrentLayout={setCurrentTransactionLayout}
                                    />
                                </TabItem>
                                <TabItem 
                                    title="Storage Charges" 
                                    disabled={
                                        !formFields.TRANSACTIONHEADERID || 
                                        formFields.TRANSACTIONHEADERID === '00000000-0000-0000-0000-000000000000' ||
                                        formFields.TRANSACTIONTYPE !== 'C'
                                    }
                                >
                                    <StorageChargesTab 
                                        transactionHeaderId={formFields.TRANSACTIONHEADERID}
                                        accessToken={accessToken}
                                        customerId={formFields.CUSTOMER}
                                        itemsGridRef={storageItemsGridRef}
                                        chargesGridRef={storageChargesGridRef}
                                        selectedItemsKeys={selectedStorageItemsKeys}
                                        setSelectedItemsKeys={setSelectedStorageItemsKeys}
                                        selectedChargesKeys={selectedStorageChargesKeys}
                                        setSelectedChargesKeys={setSelectedStorageChargesKeys}
                                        currentItemsLayout={currentStorageItemsLayout}
                                        setCurrentItemsLayout={setCurrentStorageItemsLayout}
                                        currentChargesLayout={currentStorageChargesLayout}
                                        setCurrentChargesLayout={setCurrentStorageChargesLayout}
                                        
                                    />
                                </TabItem>
                            </TabPanel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}




function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(Form);

